// Copyright (c) 2019 Deere & Company

import { buildNumberString } from './build-number-string';

export const buildNumber = (number, options = {}, decimalFormatKey) => {

    const decimalFormat = decimalFormatKey;

    return (
        typeof number === 'undefined' || number === null ?
            '' :
            buildNumberString(decimalFormat, number, options)
    );

};

export const buildCurrency = (number, options = {}) => buildNumber(number, {
    ...options,
    minimumFractionDigits: 2,
});

export const buildReportCurrency = (number) => buildCurrency(number || 0);
